import { useEffect, useState } from "react";
import { useRouter } from "next/router";

import { STEP_CART, STEPS, STEP_ACCOUNT } from "components/funnel/constants";
import useUser from "hooks/useUser";
import useCart from "hooks/useCart";
import useProductValidator from "hooks/useProductValidator";
import { validatedStep } from "components/funnel/utils";
import { STEP_PRODUCT_COLLECTION } from "../components/funnel/constants";

export default function useFunnelValidator(currentStep) {
  const [cart] = useCart();
  const [user] = useUser();
  const [allCartItemsAreAvailable, checkProductsAvailability] = useProductValidator();
  const { push, asPath } = useRouter();

  // Initialise to true when we are reloading a page or on account page, but false if we
  // were routed there
  const [isRouting, setIsRouting] = useState(
    !cart || currentStep === STEP_ACCOUNT || currentStep === STEP_PRODUCT_COLLECTION
  );

  useEffect(() => {
    checkProductsAvailability();
  }, [asPath, checkProductsAvailability]);

  useEffect(() => {
    if (cart) {
      const maxValidatedStep = validatedStep(cart, user, allCartItemsAreAvailable);
      if (maxValidatedStep === STEP_CART && currentStep !== STEP_CART && isRouting) {
        // If url step is after max validated step, route to max validated step
        push("/reconditionne/panier");
      } else if (
        STEPS.findIndex((s) => s === maxValidatedStep) < STEPS.findIndex((s) => s === currentStep) &&
        isRouting
      ) {
        push(`/reconditionne/panier/${maxValidatedStep}`);
      } else if (
        ((currentStep === STEP_ACCOUNT &&
          STEPS.findIndex((s) => s === maxValidatedStep) > STEPS.findIndex((s) => s === currentStep)) ||
          (currentStep === STEP_PRODUCT_COLLECTION && !cart?.shipping?.recoverOldDevice)) &&
        isRouting
      ) {
        push(`/reconditionne/panier/${STEPS[STEPS.findIndex((s) => s === currentStep) + 1]}`);
      } else {
        setIsRouting(false);
      }
    }
  }, [push, currentStep, cart, allCartItemsAreAvailable, isRouting, user]);

  const isValidating = isRouting;

  return [isValidating];
}
